'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('voter-group-list', {
      url: '/voter-group/list',
      template: '<voter-group-list></voter-group-list>',
        authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/voter-group/voter-group-list/voter-group-list.routes.js